import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

export const disciplineSchema = z.object({
  name: z.string().min(3),
  headOfDiscipline: identitySchema,
  department: identitySchema,
});

export const defaultDisciplineValues: DefaultValues<DisciplineSchema> = {
  name: '',
};

export type DisciplineSchema = z.infer<typeof disciplineSchema>;
